import { ProjectGroupBaseDTO } from '@mottmac-moata/identity-sdk';
import { renderPlaceholderTemplate } from '@/utils/renderPlaceholderTemplate';

export const getDefaultInviteMessage = (
  selectedGroupIds: string[],
  inviteTemplate = '',
  groups?: ProjectGroupBaseDTO[],
  projectName = '',
  sender = ''
): string => {
  const groupNames =
    groups
      ?.filter((group) => selectedGroupIds.includes(group.groupId))
      .map((group) => group.name)
      ?.join(', ') ?? '';

  return renderPlaceholderTemplate(inviteTemplate, { projectName, groupNames, sender });
};
